import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import { getAppSettings } from "@/shared/config/app-settings";

// Same prefix @shipbob/auth used, so existing sessions in localStorage survive the migration.
const AUTH_PREFIX = "shipbob_auth_";

let userManager: UserManager | null = null;

export function getUserManager(): UserManager {
  if (!userManager) {
    const appSettings = getAppSettings();

    userManager = new UserManager({
      authority: appSettings.authAuthority,
      client_id: appSettings.authClientId,
      scope: appSettings.authScope,
      response_type: "code",
      // import.meta.env.BASE_URL always ends with "/", so this stays a single
      // slash between the base and the callback path at any deploy subpath
      // (root deploys keep BASE_URL === "/", identical to the old behavior).
      redirect_uri: new URL(
        `${import.meta.env.BASE_URL}signin-callback`,
        globalThis.location.origin,
      ).toString(),
      post_logout_redirect_uri: new URL(
        import.meta.env.BASE_URL,
        globalThis.location.origin,
      ).toString(),
      automaticSilentRenew: true,
      userStore: new WebStorageStateStore({
        prefix: AUTH_PREFIX,
        store: globalThis.localStorage,
      }),
    });
  }

  return userManager;
}
